import React from "react";

const BoxSection = () => {
  return (
    <div className="box">
      <div className="container box-section position-relative">
        <img src="/image/box-logo.png"  alt="" />
        <div className="row d-flex align-items-center ">
          <div className=" col-md-8">
            <div className="box-content text-md-start text-center mb-md-0 mb-5">
                <h2 className="text-white mb-md-4 mb-3" data-aos='fade-up'  >Earn Up To $13 Worth Of Crypto</h2>
                <p data-aos='fade-up'  >Discover How Specific Cryptocurrencies Work — And Get A Bit Of Each Crypto To Try Out For Yourself.</p>
            </div>
          </div>
          <div className=" col-md-4 d-flex align-items-center justify-content-center ">
            <a href="#" className="btn btn-primary" data-aos='fade-up'  >Start earning</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxSection;
